import TeamMotivationSurvey from './TeamMotivationSurvey';

export default TeamMotivationSurvey;